import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "typeSelect", "stateSelect" ]

  connect() {
    this.waitForTomSelect(() => {
      const typeTomSelect = this.typeSelectTarget.tomselect
      const stateTomSelect = this.stateSelectTarget.tomselect

      typeTomSelect.on("change", () => {
        this.filterStates()
        this.forceCloseAll()
      })

      stateTomSelect.on("dropdown_open", () => {
        this.filterStates()
      })

      this.filterStates()
      this.forceCloseAll()
    })
  }

  waitForTomSelect(callback) {
    const check = () => {
      if (this.typeSelectTarget?.tomselect && this.stateSelectTarget?.tomselect) {
        callback()
      } else {
        setTimeout(check, 30)
      }
    }
    check()
  }

  forceCloseAll() {
    setTimeout(() => {
      this.typeSelectTarget?.tomselect?.close()
      this.stateSelectTarget?.tomselect?.close()

      this.typeSelectTarget?.tomselect?.control_input?.blur()
      this.stateSelectTarget?.tomselect?.control_input?.blur()
      this.typeSelectTarget?.tomselect?.control?.blur()
      this.stateSelectTarget?.tomselect?.control?.blur()

      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur()
      }
    }, 40)
  }

  filterStates() {
    const typeTomSelect = this.typeSelectTarget.tomselect
    const stateTomSelect = this.stateSelectTarget.tomselect

    if (!typeTomSelect || !stateTomSelect) return

    const selectedTypes = Array.isArray(typeTomSelect.getValue())
      ? typeTomSelect.getValue()
      : [typeTomSelect.getValue()].filter(Boolean)

    Object.values(stateTomSelect.options).forEach(option => {
      const optionType = option.type || option.$option?.dataset?.type
      const shouldShow = selectedTypes.length === 0 ||
        optionType === "all" ||
        selectedTypes.includes(optionType)

      if (!shouldShow) {
        if (stateTomSelect.items.includes(String(option.value))) {
          stateTomSelect.removeItem(option.value, true)
        }
      }
    })

    stateTomSelect.refreshItems()

    const dropdownContent = stateTomSelect.dropdown_content
    if (!dropdownContent) return

    Object.values(stateTomSelect.options).forEach(option => {
      const dropdownItem = dropdownContent.querySelector(`[data-value="${option.value}"]`)
      if (!dropdownItem) return

      const optionType = option.type || option.$option?.dataset?.type
      const shouldShow = selectedTypes.length === 0 ||
        optionType === "all" ||
        selectedTypes.includes(optionType)

      if (shouldShow) {
        dropdownItem.style.removeProperty("display")
        dropdownItem.classList.remove("filtered-out")
      } else {
        dropdownItem.style.display = "none"
        dropdownItem.classList.add("filtered-out")
      }
    })

    const optgroupHeaders = dropdownContent.querySelectorAll(".ts-optgroup-header")
    optgroupHeaders.forEach(header => {
      const optgroupContainer = header.closest(".ts-optgroup") || header.parentElement
      if (!optgroupContainer) return

      const visibleOptions = optgroupContainer.querySelectorAll(".option:not(.filtered-out)")

      if (visibleOptions.length === 0) {
        optgroupContainer.style.display = "none"
      } else {
        optgroupContainer.style.removeProperty("display")
      }
    })
  }
}
